export const HISTORY_IMAGE_ACTIONS = [
  'image',
  'Clearer',
  'Remove background',
  'Convert to sticker',
];

/** Chats that belong to a chat block on a canvas, not to the chat window. */
export const SHARED_CANVAS_CHAT_PROMPT_NAME =
  'streamlain-shared-canvas-chat-v1';

/** How long the chat window takes to follow a change of its form. */
export const CHAT_FORM_MOTION_MS = 200;
